<template>
  <!-- New Purchase Button -->
  <q-btn
    color="secondary"
    icon="money"
    label="Odeme"
    no-caps
    @click="confirm = true"
  />
  <q-dialog v-model="confirm">
    <q-card style="min-width: 350px">
      <q-card-section>
        <div class="text-h6">Yeni Odeme Kaydi</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-form class="q-gutter-md">
          <!-- Payment Type -->
          <q-select
            v-model="payment"
            filled
            :options="paymentOpt"
            label="Odeme Tipi"
          />

          <!-- Subscription Plan -->
          <q-select
            v-model="subscription"
            filled
            :options="subscriptionOpt"
            label="Paket"
            option-label="title"
            option-value="id"
          />

          <!-- Purchase Timestamp -->
          <q-input v-model="timestamp" filled label="Odeme Gunu">
            <template #append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  ref="qDateProxy"
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date v-model="timestamp" mask="DD-MM-YYYY">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Kapat" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </q-form>
      </q-card-section>

      <q-card-actions align="right" class="text-primary">
        <q-btn v-close-popup flat label="Vazgec" color="red" />
        <q-btn
          v-close-popup
          flat
          label="Kaydet"
          color="secondary"
          @click="createPurchase"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
import { ref, toRefs, inject } from 'vue'
import axios from 'axios'
import { useQuasar } from 'quasar'
import moment from 'moment'
import * as notify from '../../utils/notification'
import * as mappers from '../../utils/mapper'
import * as eventNames from '../../utils/events'
export default {
  props: {
    customerId: String,
  },
  setup(props) {
    const $q = useQuasar()
    let { customerId } = toRefs(props)
    const emitter = inject('emitter')

    const payment = ref(null)
    const subscription = ref(null)
    const timestamp = ref(null)

    // Available subscription plans
    const subscriptionOpt = ref([])
    axios.get('/subscriptions').then((response) => {
      subscriptionOpt.value = response.data
    })

    const createPurchase = () => {
      axios
        .post('/purchase/', {
          customerId: customerId.value,
          subscriptionId: subscription.value.id,
          paymentType: payment.value.value,
          timestamp: moment(timestamp.value, 'DD-MM-YYYY').toISOString(),
        })
        .then(() => {
          $q.notify(notify.success('Odeme basariyla alindi.'))
          emitter.emit(eventNames.REFRESH_CUSTOMER)
        })
        .catch(() => {
          $q.notify(notify.warning('Odeme basarisiz.'))
        })
    }

    return {
      confirm: ref(false),
      payment,
      subscription,
      timestamp,
      subscriptionOpt,
      paymentOpt: mappers.paymentOptions(),
      createPurchase,
    }
  },
}
</script>
